<p-toast></p-toast>

<div class="table">
  <!-- Filter SideBar -->
  <p-drawer 
    class="filterSidebar" 
    [transitionOptions]="'0ms'" 
    [(visible)]="showFilterSidebar" 
    (onHide)="getAllRoles()" 
    [style]="{padding: '0', border: '2px solid white'}" 
    [modal]="false" 
    [baseZIndex]="0" 
    ariaCloseLabel="Filter">
    <p class="sidebar-title">Filter</p>
    <span class="p-input-icon-left">
      <em class="pi pi-search"></em>
      <input type="text" pInputText placeholder="Search" [(ngModel)]="filterSearchTerm">
    </span>
    <div class="filterSidebarContent">
      <div class="sidebar-bottom">
        <div class="sidebar-bottom-apply">
          <p class="sidebar-bottom-text" (click)="displaySaveFilterSettings = true;">Save Selected Filters</p>
          <div class="sidebar-bottom-buttons">
            <button pButton pRipple type="button" label="Clear" class="p-button-outlined"></button>
            <button pButton pRipple type="button" label="Apply"></button>
          </div>
        </div>
        <div class="sidebar-saveSettings" [ngClass]="{'hidden' : !displaySaveFilterSettings}">
          <em class="pi pi-times" (click)="displaySaveFilterSettings = false"></em>
          <div class="p-inputgroup">
            <input type="text" pInputText placeholder="Enter Filter Name">
            <button type="button" pButton pRipple label="Save"></button>
          </div>
        </div>
      </div>
    </div>
  </p-drawer>

  <!-- Column Settings Sidebar -->
  <p-drawer   
    styleClass="settingsSidebar"   
    [transitionOptions]="'300ms'"   
    [(visible)]="showSettingsSidebar"   
    [modal]="false"  
    position="right"  
    (onShow)="updatedSelectedColFields()"
    [showCloseIcon]="false"  
    [baseZIndex]="1000">
    
    <div class="settings-sidebar-header">
      <h3 class="settings-sidebar-title">Column Settings</h3>
    </div>  
    <div class="settings-sidebar-center">
      <div class="settings-content-container">
        <!-- Search -->
        <div class="settings-search-container">
          <i class="pi pi-search"></i>
          <input 
            type="text"
            class="settings-search-input"
            placeholder="Search" 
            [(ngModel)]="columnSearchTerm"
            (ngModelChange)="searchColumns($event)" />
        </div>
        
        <div class="saved-columns-section" *ngIf="savedColumnSettings.length > 0">
          <div class="saved-columns-header">Saved Columns</div>
          <div class="saved-column-item" *ngFor="let column of savedColumnSettings" (click)="applySavedSettings(column.saved_columns)">
            <span class="saved-column-name">{{column.name}}</span>
            <i class="pi pi-trash saved-column-delete" (click)="$event.stopPropagation(); deleteSavedColumns(column.id)"></i>
          </div>
        </div>
        
        <!-- Column Selection -->
        <div class="settings-columns-section">
          <div class="settings-column-item" *ngFor="let col of __rolesCol">
            <div class="column-item-left">
              <!-- <p-checkbox 
                name="category"
                [value]="col"
                [(ngModel)]="checkedColumns"
                [inputId]="col.field">
              </p-checkbox> -->
              <p-checkbox name="category" [value]="col.field" [ngModel]="checkedColumnsFields"
                (ngModelChange)="updateCheckedColumns($event)" [inputId]="col.field">
              </p-checkbox>
              <label [for]="col.field" class="settings-column-label">{{col.header}}</label>
            </div>
            <i class="fas fa-grip-vertical drag-handle"></i>
          </div>
        </div>
        
        <!-- Save Settings Section -->
        <div class="save-settings-section" *ngIf="!displaySaveColumnSettings">
          <div class="save-settings-toggle" (click)="displaySaveColumnSettings = true">
            Save Selected Columns      
          </div>
        </div>
        
        <!-- Save Form -->
        <div class="save-settings-section" *ngIf="displaySaveColumnSettings">
          <form class="save-settings-form" [formGroup]="columnSettings" (ngSubmit)="saveColumnSettings()">
            <input 
              type="text"
              class="save-settings-input"
              placeholder="Enter Column Set Name" 
              formControlName="name">
            <button type="submit" pButton class="save-settings-btn" label="Save"></button>
            <button type="button" pButton class="p-button-text" (click)="clearColumnPreferenceName()">
              <i class="pi pi-times"></i>
            </button>
          </form>
        </div>
      </div>
    </div>
    
    <!-- Footer with #FCFBFF background -->
    <div class="settings-actions">
      <button 
        pButton 
        class="settings-cancel-btn"
        [outlined]="true"
        label="Cancel"
        (click)="showSettingsSidebar = false; clearColumnPreferenceName()">
      </button>
      <button 
        pButton 
        class="settings-apply-btn"
        label="Apply"
        (click)="applySelectedColumns()">
      </button>
    </div>
  </p-drawer>

  <!-- Download Sidebar -->
  <p-drawer   
    styleClass="downloadSidebar roleListDownload"   
    [transitionOptions]="'300ms'"   
    [(visible)]="showDownloadSidebar"   
    [modal]="false"  
    position="right"  
    [showCloseIcon]="false"  
    [baseZIndex]="1000">
    
    <!-- Header -->
    <div class="download-sidebar-header">
      <div class="header-top-row">
        <h3 class="download-sidebar-title">Download Role Data</h3>
        <div class="format-toggle">
          <div class="format-option">
            <div class="format-radio" [ngClass]="{'active': downloadAs === 'csv'}" (click)="downloadAs = 'csv'">
              <i class="pi pi-check" *ngIf="downloadAs === 'csv'"></i>
            </div>
            <span class="format-label" (click)="downloadAs = 'csv'">CSV</span>
          </div>
          <div class="format-option">
            <div class="format-radio" [ngClass]="{'active': downloadAs === 'excel'}" (click)="downloadAs = 'excel'">
              <i class="pi pi-check" *ngIf="downloadAs === 'excel'"></i>
            </div>
            <span class="format-label" (click)="downloadAs = 'excel'">EXCEL</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Content Area -->
    <div class="download-sidebar-content">
      <div class="download-columns-section">
        <div class="download-column-item select-all-item">
          <p-checkbox           
            [(ngModel)]="selectAllColumns"           
            (onChange)="toggleSelectAll()"          
            [binary]="true"
            inputId="selectAll">        
          </p-checkbox>        
          <label for="selectAll" class="download-column-label">Select All</label>      
        </div>
        
        <!-- Regular Column Items -->
        <div class="download-column-item" *ngFor="let col of colsToDownload">
          <p-checkbox           
            name="downloadColumns"           
            [value]="col"           
            [(ngModel)]="checkedColumns"           
            [inputId]="col.field"
            (onChange)="onColumnCheckChange()">        
          </p-checkbox>        
          <label [for]="col.field" class="download-column-label">{{col.header}}</label>      
        </div>
      </div>
    </div>
    
    <!-- Action Buttons -->
    <div class="download-actions">
      <div class="download-buttons-row">
        <button         
          pButton         
          class="cancel-btn"         
          label="Cancel"       
          [outlined]="true" 
          (click)="showDownloadSidebar = false; resetCheckedColumnsToDefault()">      
        </button>      
        <button         
          pButton         
          class="download-btn"         
          label="Download"         
          [disabled]="checkedColumns.length === 0"        
          (click)="(downloadAs === 'excel') ? exportRole('Excel') : exportRole('csv')">      
        </button>    
      </div>
    </div>
  </p-drawer>
    
  <!-- Filter Tabs Container with Dynamic Role Types -->
  <div class="filter-tabs-container">
    <div class="filter-tabs" [ngClass]="{'scrollable': dynamicRoleTypes.length > 6}">
      <div class="filter-tab" 
           [ngClass]="{'active': statusSelected === 'All'}" 
           (click)="getRolesByFilter('All'); setStatus('All')">
        All Roles
        <span class="role-count" *ngIf="statusSelected === 'All'">{{ totalLength || 0 }}</span>
      </div>
      <div class="filter-tab" 
           *ngFor="let roleType of dynamicRoleTypes"
           [ngClass]="{'active': statusSelected === roleType.id}" 
           (click)="getRolesByFilter(roleType.id); setStatus(roleType.name)">
        {{ roleType.name }}
        <span class="role-count" *ngIf="statusSelected === roleType.id">{{ totalLength || 0 }}</span>
      </div>
    </div>

    <!-- Table Controls -->
    <div class="table-controls">
      <button pButton class="control-btn" pTooltip="Column Settings" tooltipPosition="top" (click)="showFilterSidebar = false; showSettingsSidebar = true; showDownloadSidebar = false">
        <img src="assets/icons-svg/column-setting.svg" alt="Settings" />
      </button>
      <button pButton class="control-btn" (click)="showDownloadSidebar = true; showSettingsSidebar = false; showFilterSidebar = false" pTooltip="Download" tooltipPosition="top">
        <img src="assets/icons-svg/download.svg" alt="Download" />
      </button>
      <button pButton class="control-btn" pTooltip="Refresh" tooltipPosition="top" (click)="refreshTable()">
        <img src="assets/icons-svg/refresh.svg" alt="Refresh" />
      </button>
      <span class="table-menu">
        <p-select
        class="view-list-dropdown" 
          [options]="pageLimits" 
          [(ngModel)]="pageSize" 
          (onChange)="getRolesByLimit()">
        </p-select>
        <button pButton (click)="prev()" [disabled]="isFirstPage() || loadingSpinner" class="p-button-secondary p-button-text simple-btn">
          <img src="assets/icons-svg/chevron-left.svg" alt="Previous" class="icon-svg">
        </button>
        <button pButton class="disabled p-button-secondary p-button-text simple-btn">{{ loadingSpinner ? '...' : pageNumber + ' of ' + totalPages }}</button>
        <button pButton (click)="next()" [disabled]="isLastPage() || loadingSpinner" class="p-button-secondary p-button-text simple-btn">
          <img src="assets/icons-svg/chevron-right.svg" alt="Next" class="icon-svg">
        </button>
      </span>
    </div>
  </div>

  <!-- Main Table Container -->
  <div class="main-table-container">
    <p-table 
      #dt 
      [columns]="_selectedColumns" 
      [value]="loadingSpinner ? skeletonData : roleList" 
      [resizableColumns]="true" 
      [rows]="pageSize" 
      [loading]="false" 
      [scrollable]="true" 
      scrollDirection="both" 
      responsiveLayout="scroll" 
      dataKey="id" 
      [selection]="selectedRoles" 
      (selectionChange)="onSelectedRoleChange($event)" 
      [exportFilename]="exportName"
      styleClass="modern-table">
      
      <ng-template pTemplate="header" let-columns>
        <tr class="modern-table-header" [ngClass]="{'moveTable': showFilterSidebar || showSettingsSidebar || showDownloadSidebar}">
          <th scope="col" class="checkbox-column" pFrozenColumn>
            <div class="checkbox-container" *ngIf="!loadingSpinner && roleList.length">
              <p-tableHeaderCheckbox [disabled]="loadingSpinner"></p-tableHeaderCheckbox>
            </div>
          </th>
          <th class="role-name-column" scope="col" pResizableColumn pFrozenColumn>
            ROLE NAME
            <p-sortIcon class="sort-icon" field="name"></p-sortIcon>
          </th>
          <th [style]="{width: '11vw'}" scope="col" pSortableColumn="{{ col.sortable ? col.field : null }}" *ngFor="let col of columns" pResizableColumn>
            {{ col.header }}
            <p-sortIcon *ngIf="col.sortable" class="sort-icon" field="{{ col.field }}"></p-sortIcon>
          </th>
          <th scope="col" class="action-column">ACTION</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-role let-columns="columns">
        <tr class="modern-table-row" [ngClass]="{'moveTable': showFilterSidebar || showSettingsSidebar || showDownloadSidebar, 'skeleton-row': loadingSpinner}" [style]="{cursor: loadingSpinner ? 'default' : 'pointer'}">
          <td class="checkbox-column" pFrozenColumn>
            <div class="checkbox-container">
              <ng-container *ngIf="!loadingSpinner; else skeletonCheckbox">
                <p-tableCheckbox [value]="role"></p-tableCheckbox>
              </ng-container>
              <ng-template #skeletonCheckbox>
                <div class="skeleton skeleton-checkbox"></div>
              </ng-template>
            </div>
          </td>
          <td 
            (click)="!loadingSpinner && openRoleDetails(role)" 
            class="role-name-column" 
            pFrozenColumn>
            <ng-container *ngIf="!loadingSpinner; else skeletonText">
              <div class="role-name-content">
                <span class="role-name">{{ role.name }}</span>
                <span class="role-id" 
                      (click)="$event.stopPropagation(); copyToClipboard(role.id, 'Role ID')"
                      (keydown.enter)="copyToClipboard(role.id, 'Role ID')"
                      (keydown.space)="copyToClipboard(role.id, 'Role ID')"
                      title="Click to copy Role ID"
                      role="button"
                      tabindex="0"
                      [attr.aria-label]="'Role ID: ' + role.id + '. Click to copy to clipboard'">
                  {{ role.id }}
                </span>
              </div>
              
            </ng-container>
            <ng-template #skeletonText>
              <div class="skeleton skeleton-text skeleton-text-long"></div>
            </ng-template>
          </td>
          <td *ngFor="let col of columns" 
              (click)="!loadingSpinner && openRoleDetails(role)" 
              [style]="{width: '11vw'}">
            <ng-container *ngIf="!loadingSpinner; else skeletonCell">
              <span [ngSwitch]="true" class="box-data">
                <span *ngSwitchCase="col.field === 'work_mode'" 
                class="modern-status-badge work-mode-badge"
                [style.background-color]="getWorkModeColor(role[col.field])"
                [style.color]="getWorkModeTextColor(role[col.field])">
                {{ role[col.field] ? (role[col.field] | titlecase) : '-' }}
              </span>
                <span *ngSwitchCase="col.field === 'location' || col.field === 'opening'"
                  class="locations-op">
                  <span class="location-name-text">{{ role[col.field][0] }}</span>
                  <div *ngIf="role[col.field].length > 1" class="remainingItems-badge">
                    <p-badge 
                      value="+{{ role[col.field].length - 1 }}" 
                      styleClass="mr-2" 
                      [pTooltip]="getLocationTooltip(role[col.field])" 
                      tooltipPosition="top"
                      [escape]="false">
                    </p-badge>
                  </div>
                </span>
                <span *ngSwitchDefault>
                  {{ role[col.field] ? role[col.field] : '-' }}
                </span>
              </span>
            </ng-container>
            <ng-template #skeletonCell>
              <div class="skeleton" [ngClass]="{
                'skeleton-badge': col.field === 'work_mode',
                'skeleton-text': col.field !== 'work_mode',
                'skeleton-text-short': col.field === 'location' || col.field === 'opening'
              }"></div>
            </ng-template>
          </td>
          <td class="action-column">
            <ng-container *ngIf="!loadingSpinner; else skeletonAction">
              <span 
                *ngIf="userPrivileges.has('job_role.delete')"
                class="delete-link"
                (click)="$event.stopPropagation(); deleteRole(role)"
                [class.disabled]="role.candidateCount > 0"
                [title]="role.candidateCount > 0 ? 'Cannot delete role with candidates' : 'Delete role'">
                Delete
              </span>
            </ng-container>
            <ng-template #skeletonAction>
              <div class="skeleton skeleton-text skeleton-text-short"></div>
            </ng-template>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="_selectedColumns.length + 2" class="empty-message-container">
            <div class="empty-state">
              <div class="empty-state-icon">
                <i class="pi pi-search"></i>
              </div>
              <h3 class="empty-state-title">No Roles Found</h3>
              <p class="empty-state-description">
                Try adjusting filters or search terms.
              </p>
            </div>
          </td>
        </tr>
      </ng-template>     
    </p-table>
  </div>
</div>

<!-- Keep existing sidebars for role details, add role, etc. -->
<div *ngIf="showAddRole">
  <p-drawer *ngIf="userPrivileges.has('job_role.update') || userPrivileges.has('job_role.create')"
    class="addRole-slider" [(visible)]="showAddRole" styleClass="p-drawer-lg"
    [showCloseIcon]="true" position="right">
    <div style="position:relative">
      <app-role-add [data]="rowData" (closeAddRole)="onCloseAddRole($event)">
      </app-role-add>
    </div>
  </p-drawer>
</div>

<p-drawer 
  class="viewRole-sidebar" 
  [(visible)]="showViewRoleSidebar" 
  [showCloseIcon]="true" 
  position="right" 
  styleClass="p-drawer-lg">
  <!-- Keep your existing role details sidebar content -->
</p-drawer>